import styled from 'styled-components/macro';

export const Ol = styled.ol<{ margin?: string }>`
  margin: ${({ theme, margin }) =>
    margin ? margin : `${theme.spacing.one} ${theme.spacing.zero}`};
`;

export const Li = styled.li`
  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.md};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};

  ::marker {
    font-weight: 600;
  }
`;
